import React from 'react';

import VideoWizardClipsExportStep from './VideoWizardClipsExportStep';
import VideoWizardFullEpisodeExportStep from './VideoWizardFullEpisodeExportStep';

export interface VideoWizardExportStepProps {
  isFullEpisode: boolean;
  mainVideoSrc: File | string;
  onError?: (error: Error) => void;
  videoFileSize?: number;
}

const VideoWizardExportStep: React.FC<VideoWizardExportStepProps> = ({
  isFullEpisode,
  mainVideoSrc,
  onError,
  videoFileSize,
}) => {
  return isFullEpisode ? (
    <VideoWizardFullEpisodeExportStep {...{ mainVideoSrc, onError }} />
  ) : (
    <VideoWizardClipsExportStep {...{ onError, videoFileSize }} />
  );
};

export default VideoWizardExportStep;
